import { KatalComponent } from '../../shared/base';

/**
 * Subcomponent for the individual steps.
 * For now this is not exposed and devs should use the JSON attribute on the parent component to generate these.
 */
export class KatalWorkflowtrackerStep extends KatalComponent {
  static get observedAttributes() {
    return ['state', 'label'];
  }

  constructor() {
    super(KatalWorkflowtrackerStep.observedAttributes);
  }

  connectedCallback() {
    super.connectedCallback();
    this.render();
    this.connectedEvents();
  }

  /**
   * @classprop {enum} state Show success message instead of form
   * @enum {value} complete Completed step
   * @enum {value} in-progress Step currently being worked on (or navigated to)
   * @enum {value} todo Step that has not been completed yet
   * @required
   */
  get state() {
    return this.getAttribute('state') || '';
  }

  set state(value) {
    this.removeOrSetAttribute('state', value);
  }

  /**
   * @classprop {string} label Label that describes what the workflow step represents
   */
  get label() {
    return this.getAttribute('label') || '';
  }

  set label(value) {
    this.setAttribute('label', value);
  }

  /**
   * @classprop {boolean} clickable Allows step to be clickable
   */
  get clickable() {
    return this.getBooleanAttribute('clickable');
  }

  set clickable(value) {
    this.setBooleanAttribute('clickable', value);
  }

  render() {
    const createAndAppendElement = (parent, elementTag) => {
      const element = document.createElement(elementTag);
      parent.appendChild(element);

      return element;
    };

    this.innerHTML = '';

    const stepMarker = createAndAppendElement(this, 'span');
    stepMarker.setAttribute('class', 'step-marker');

    const stepText = createAndAppendElement(this, 'span');
    stepText.setAttribute('class', 'step-text');

    const stepLabel = createAndAppendElement(stepText, 'span');
    stepLabel.setAttribute('class', 'step-label');
    stepLabel.innerHTML = this.sanitizeAndAddSoftHyphensToLabel(this.label, 5);
  }

  // This will add a soft hyphen every 5 characters in words that are 5 characters or longer
  // https://css-tricks.com/almanac/properties/h/hyphenate/
  sanitizeAndAddSoftHyphensToLabel(label, num) {
    // sanitize label
    const cleanDiv = document.createElement('div');
    cleanDiv.innerText = label;
    const sanitizedLabel = cleanDiv.innerHTML;

    // add soft hyphens
    return sanitizedLabel.replace(
      RegExp('(\\w{' + num + '})(\\w)', 'g'),
      function(all, text, char) {
        return text + '&shy;' + char;
      }
    );
  }

  connectedEvents() {
    this.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (!this.clickable) {
        return;
      }

      this.dispatchCustomEvent('step', { step: this.getAttribute('id') });
    });
  }

  // Respond to attribute changes.
  attributeChangedCallback() {
    this.render();
  }
}
